import { request } from "@/api/all";

export default {
  namespaced: true,
  state: {
    boxNames: [],
    boxSummary: [],
    boxNamesFilter:{
      templateId: null,
      departId: null,
    },
    boxSummaryFilter:{
      templateId: null,
      departId: null,
      startDate: null,
      endDate: null,
      newbieId: null,
    },
    templates: [],
    greeting: false,
  },
  mutations: {
    setBoxNames(state, list) {
      state.boxNames = list;
    },
    setTemplates(state, list) {
      list.unshift({id: 0, name: 'Бүгд'});
      // list= list.map(state => ({ ...list, active: false }));
      const updatedArray = list.map((item, ind) => ({
          ...item, // Spread existing properties
          active: ind===0 // Add the new field
      }));
      state.templates = updatedArray;
    },
    setNamesFilter(state, value){
      state.boxNamesFilter = value;
    },
    setBoxFilter(state, value){
      state.boxSummaryFilter = value;
      if(value!=undefined && value!=null){
        if(value.templateId!=undefined && value.templateId!=null){
          //todo
          state.templates = state.templates.map(template => ({
              ...template,
              active: template.id === value.templateId // Set active to true if ids match
          }));
        }
      }
    },
    setBoxSummary(state, list) {
      let levels= list;
      // if (levels.length > 0) {
      //   // console.log('x1');
      //   const firstItem = JSON.parse(JSON.stringify(levels[0]));
      //   // console.log('x1_1', firstItem);
      //   firstItem.code = 0;
      //   firstItem.boxName = "Бэлтгэл үе";
      //   levels.unshift(firstItem); // Add the first item again to the end of the array 
      // }

      state.boxSummary = levels;
    },
    setGreeting(state, show) {
      state.greeting = show;
    }
  },
  actions: {
    handleGreeting({ commit, rootState }, { show }) { 
      if (show) {
        const greetingCount = localStorage.getItem(`bgc_${rootState.user.userId}`);
        if (greetingCount === null) {
          localStorage.setItem(`bgc_${rootState.user.userId}`, '1');
          commit("setGreeting", show);
        } else if (parseInt(greetingCount) < 3) {
          localStorage.setItem(`bgc_${rootState.user.userId}`, (parseInt(greetingCount) + 1).toString());
          commit("setGreeting", show);
        }
      } else {
        commit("setGreeting", show);
      }
    },
    handleBoxNames({ state, commit, dispatch }, { filter, store }) {
      if(filter!=undefined){
        commit("setNamesFilter", filter);  
      }
      // console.log('f1');
      return new Promise((resolve, reject) => {
        try {
          request(
            { api: { method: "POST", url: "buddy/admin/getBoxNames" }, 
            data: state.boxNamesFilter,
            store: store 
          })
            .then(res => {
              // console.log('f1 buddy/admin/getBoxNames', res);
              commit("setBoxNames", res.data.list);
              if(filter!=undefined){
                resolve(true);
              }else {
                commit("setTemplates", res.data.templates);
                return dispatch('handleBoxSummary', { store });
              }
            })
            .catch(err => { reject(err); });
        } catch (error) { reject(error); }
      });
    },
    handleBoxSummary({ state, dispatch, commit }, { filter, store }) {
      // console.log('state.boxSummaryFilter', state.boxSummaryFilter);
      if(filter!=undefined){
        commit("setBoxFilter", filter);  
      } else{
        Object.keys(state.boxSummaryFilter).forEach(key => {
          state.boxSummaryFilter[key] = null;
        });
      }
      
      // dispatch('app/handleLoading', { isLoading: true });
      return new Promise((resolve, reject) => {
        try {
          request({ api: { method: "POST", url: "buddy/admin/GetBoxSummary" }, 
            data:state.boxSummaryFilter,
            store: store })
            .then(res => {
              // console.log('f2 ', res, res.data.list.length);
              // res.data.list.forEach(item => {
              //   console.log(`Name: ${item.boxName}, Progress: ${item.progress}`);
              // });
              commit("setBoxSummary", res.data.list);
              resolve(true);
            })
            .catch(err => { reject(err); });
        } catch (error) { reject(error); }
      });
    }
  }
};
